module.exports = __webpack_public_path__ + "img/reaction13.8880cbd3.png";